import { $http } from '../component-base/xhr';
import Cookies from 'js-cookie';
import { useBridge } from '../../utils/bridge/common';
const STORAGE_KEY = 'KS_CSC_COLLECT_SEARCH_HISTORY';


export function getUserId() {
    return Cookies.get('userId') || Cookies.get('ud');
}


function getPublicParams() {
    const params = new URLSearchParams(location.search);
    const entranceId = params.get('entranceId') || '1';
    const res = {};
    if (entranceId) {
        res.entranceId = +entranceId;
    }
    return res;
}

const publicParams = getPublicParams();

export async function getHistory() {
    const searchHistory = localStorage.getItem(STORAGE_KEY) || JSON.stringify([]);
    return JSON.parse(searchHistory);
}
export async function setHistory(data) {
    if (data === '') {
        localStorage.setItem(STORAGE_KEY, JSON.stringify([]));
        return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}
export async function fetchWorkDetail(params) {
    const res = await $http.post('/rest/csc/center/photo/get', {
        ...publicParams,
        ...params,
    });
    return res.data;
}
export async function fetchWorkRecent(params) {
    const nameSpaceApi = 'feed.getHistory';
    const bridgeParams = {
        type: 1,
    };

    const res = await useBridge(nameSpaceApi, bridgeParams);
    delete res.result;
    const sortData = [];
    const keys = Object.keys(res);
    Object.values(res)
        .sort((a, b) => b - a)
        .map(item => {
            const item2
                = keys.find(item1 => {
                    return res[item1] === item;
                }) || -1;
            sortData.push(item2);
        });
    const { offset } = params;
    const { data } = await $http.post('/rest/csc/center/photo/batch-get', {
        ...publicParams,
        ...params,
        encrypted: true,
        photoIdList: sortData.slice(offset, offset + 10),
    });
    const { photoList } = data.data;
    const list = photoList.map(item => item);
    const result = { hasMore: offset + 10 < sortData.length, list };
    console.log('[zy] sortData', sortData, offset, sortData.slice(offset, offset + 10), result);
    return result;
}
export async function fetchWorkList(params) {
    const res = await $http.post('/rest/csc/center/photo/list', {
        ...publicParams,
        limit: 10,
        ...params,
    });
    const { hasMore, photoList } = res.data.data;
    const list = photoList.map(item => item);
    return { hasMore, list };
}
export async function fetchWorkListV2(params) {
    const res = await $http.post('/rest/csc/center/photo/list/v2', {
        ...publicParams,
        limit: 10,
        ...params,
    });
    const { hasMore, photoList, nextCursor } = res.data.data;
    const list = photoList.map(item => item);
    return { hasMore, list, nextCursor };
}

export async function fetchLiveDetail(params) {
    const res = await $http.post('/rest/csc/center/live/get', {
        ...publicParams,
        ...params,
    });
    return res.data;
}

export async function fetchLiveRecent(params) {
    const res = await $http.post('/rest/csc/center/live/recent-list', {
        ...publicParams,
        limit: 10,
        ...params,
    });
    const { hasMore, liveList } = res.data.data;
    const list = liveList.map(item => item);
    return { hasMore, list };
}

export async function fetchLiveList(params) {
    const res = await $http.post('/rest/csc/center/live/list', {
        ...publicParams,
        limit: 10,
        ...params,
    });
    const { hasMore, liveList } = res.data.data;
    const list = liveList.map(item => item);
    return { hasMore, list };
}
export async function fetchUser(params) {
    const res = await $http.post('/rest/csc/center/user/search', {
        ...publicParams,
        count: 10,
        page: params.page,
        ...params,
    });
    return res.data;
}
function getLiveCardData(item) {
    return [
        {
            type: '',
            label: '',
            // label: '直播标题: ',
            text: item.caption || item.authorName || '',
        },
        {
            label: '主播昵称: ',
            type: '',
            text: item.authorName || '',
        },
        {
            type: 'time',
            label: '直播开始时间: ',
            time: Number(item.beginTime),
        },
    ];
}
function getWorkCardData(item) {
    return [
        {
            type: '',
            label: '',
            text: item.caption || item.authorName || '',
        },
        {
            label: '作者昵称: ',
            type: '',
            text: item.authorName || '',
        },
        {
            type: 'time',
            label: '作品发布时间: ',
            time: Number(item.uploadTime),
        },
    ];
}
export const CONFIGS = {
    selectLive: {
        getDetail: fetchLiveDetail,
        getRecentList: fetchLiveRecent,
        searchUser: fetchUser,
        getList: fetchLiveList,
        getCardData: getLiveCardData,
        tabArray: [{
            name: '最近看过',
            value: 0,
        },
        {
            name: '搜索主播',
            value: 1,
        }],
        panelTitle: '选择直播',
        emptyText: '暂无直播',
        emptyIcon: 'no-live',
    },
    selectWork: {
        getDetail: fetchWorkDetail,
        getRecentList: fetchWorkRecent,
        searchUser: fetchUser,
        getList: fetchWorkList,
        getListV2: fetchWorkListV2,
        getCardData: getWorkCardData,
        tabArray: [{
            name: '最近看过',
            value: 0,
        },
        {
            name: '搜索作者',
            value: 1,
        }],
        panelTitle: '选择作品',
        emptyText: '暂无作品',
        emptyIcon: 'no-work',
    },
};
